export {RestangularModule} from './ng2-restangular.module';
export {Restangular} from './ng2-restangular';
export {RestangularHttp} from './ng2-restangular-http';


// WEBPACK FOOTER //
// ./~/tslint-loader?emitErrors=true&failOnHint=true!./src/index.ts